import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { inRoomDiningDiscountsSelector } from '../../../servicesSlice';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';

const ItemViewDiscount = (props) => {
  const { selectedItem, currency } = props;
  const [loading, setLoading] = useState(true);
  const originalDiscounts = useSelector(inRoomDiningDiscountsSelector);
  const [itemDiscount, setItemDiscount] = useState([]);
  const [price, setPrice] = useState(0);

  useEffect(() => {
    if (selectedItem && selectedItem?.discount?.status) {
      let convertedDiscount = selectedItem?.discount?.discount.replace(/\[|\]/g, '').split(',');

      const tempDiscount = originalDiscounts?.filter((discount) =>
        convertedDiscount?.map((item) => item?.trim())?.includes(discount?.id),
      );
      setItemDiscount(tempDiscount);
      if (tempDiscount.length > 0) {
        const priceDiscountPercent = (selectedItem.price * (100 - tempDiscount[0].value)) / 100;
        const priceDiscountUpto = selectedItem.price - tempDiscount[0].upto;
        const itemPriceAfterDiscount =
          priceDiscountPercent > priceDiscountUpto ? priceDiscountPercent : priceDiscountUpto;
        setPrice(itemPriceAfterDiscount);
      }
    }
    setLoading(false);
  }, [selectedItem]);

  return (
    <>
      {loading ? (
        <div className='pt-4 col-md-12'>
          <LinearProgressBar />
        </div>
      ) : selectedItem && selectedItem.discount.status ? (
        <>
          <div className='row mx-4 mt-4'>
            <div className='col-md-6'>
              <div className='details-label'>Discount Code</div>
              <div className='details-value'>
                {itemDiscount?.map((discount) => discount?.code)?.toString()}
              </div>
            </div>
          </div>
          <div className='row mx-4 mt-4'>
            <div className='col-md-6'>
              <div className='details-label'>Item Price after Discount</div>
              <div className='details-value'>
                {currency} {price}
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className='row mx-4 mt-4'>
            <div className='col-md-6'>
              <div className='details-label'>No Discounts Available</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ItemViewDiscount;
